import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileText, Upload, Download } from 'lucide-react';
import { API } from '../../config/api';

const DOCS = [
  { key: 'participation', label: 'Δήλωση Συμμετοχής' },
  { key: 'waiver', label: 'Δήλωση Ανάληψης Κινδύνου & Αποποίησης Ευθύνης' },
];

const DocRow = ({ doc, info, headers, onDone }) => {
  const [busy, setBusy] = useState(false);
  const upload = (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { toast.error('Το αρχείο ξεπερνά τα 10MB'); return; }
    setBusy(true);
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        await axios.put(`${API}/documents/${doc.key}`, { filename: file.name, file_base64: reader.result, content_type: file.type }, { headers });
        toast.success(`Ανέβηκε: ${file.name}`);
        onDone();
      } catch (e) { toast.error('Αποτυχία ανεβάσματος'); }
      setBusy(false);
    };
    reader.readAsDataURL(file);
  };
  return (
    <div className="bg-slate-50 rounded-lg p-4 flex flex-wrap items-center gap-3" data-testid={`admin-doc-${doc.key}`}>
      <FileText className="text-[#1E3A5F]" size={20} />
      <div className="flex-1 min-w-[200px]">
        <p className="font-semibold text-[#1E3A5F]">{doc.label}</p>
        <p className="text-xs text-slate-500" data-testid={`admin-doc-${doc.key}-current`}>
          {info ? `Τρέχον: ${info.filename} (${new Date(info.uploaded_at).toLocaleDateString('el-GR')})` : 'Τρέχον: το αρχικό έντυπο της 1ης Σεζόν'}
        </p>
      </div>
      {info && (
        <a href={`${API}/documents/${doc.key}/file`} className="px-3 py-2 bg-slate-200 rounded-lg text-sm flex items-center gap-1" data-testid={`admin-doc-${doc.key}-download`}>
          <Download size={14} /> Λήψη
        </a>
      )}
      <label className={`px-3 py-2 bg-[#F97316] text-white rounded-lg text-sm flex items-center gap-1 cursor-pointer ${busy ? 'opacity-50 pointer-events-none' : ''}`} data-testid={`admin-doc-${doc.key}-upload`}>
        <Upload size={14} /> {busy ? 'Ανέβασμα...' : 'Ανέβασμα νέου'}
        <input type="file" accept=".pdf,.doc,.docx" className="hidden" onChange={e => { upload(e.target.files[0]); e.target.value = ''; }} data-testid={`admin-doc-${doc.key}-input`} />
      </label>
    </div>
  );
};

export const DocumentsManager = ({ headers }) => {
  const [docs, setDocs] = useState({});
  const load = () => axios.get(`${API}/documents`).then(res => setDocs(res.data)).catch(console.error);
  useEffect(() => { load(); }, []);
  return (
    <div className="card p-6" data-testid="admin-documents">
      <h2 className="text-xl font-bold text-[#1E3A5F] mb-1">Έντυπα Συμμετοχής</h2>
      <p className="text-sm text-slate-500 mb-4">Ανέβασε νέα έκδοση (PDF ή Word). Θα κατεβαίνει από τη σελίδα «Σχετικά» στη θέση του παλιού.</p>
      <div className="space-y-3">
        {DOCS.map(d => <DocRow key={d.key} doc={d} info={docs[d.key]} headers={headers} onDone={load} />)}
      </div>
    </div>
  );
};
